import React from 'react';
export function Footer() {
  return <footer className="w-full bg-violet-dark py-8 sm:py-12 border-t border-gold/20" data-id="element-83">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-84">
        <div className="text-center mb-6 sm:mb-8" data-id="element-85">
          <h3 className="font-display text-xl sm:text-2xl font-bold text-white mb-2" data-id="element-86">
            🛍️ MEGAPACK EMPRENDEDORA DE MODA™
          </h3>
          <p className="text-xs sm:text-sm text-violet-100/70 max-w-2xl mx-auto leading-relaxed" data-id="element-87">
            El sistema completo para emprendedoras de indumentaria en Argentina.
            Porque arrancar tu negocio de ropa no debería costarte años de
            prueba y error.
          </p>
        </div>

        <div className="flex justify-center gap-4 sm:gap-6 mb-6 sm:mb-8 text-xs sm:text-sm text-violet-100/60" data-id="element-88">
          <a href="#" className="hover:text-gold transition-colors" data-id="element-89">
            saberclick.com
          </a>
          <span data-id="element-90">·</span>
          <a href="#" className="hover:text-gold transition-colors" data-id="element-91">
            @saberclick
          </a>
        </div>

        <div className="border-t border-gold/10 pt-6 sm:pt-8 text-center" data-id="element-92">
          <p className="text-[10px] sm:text-sm text-violet-100/60 mb-3 sm:mb-4" data-id="element-93">
            © Saber Click 2024 — Todos los derechos reservados
          </p>
          <div className="flex flex-wrap justify-center gap-3 sm:gap-4 text-[10px] sm:text-xs text-violet-100/50" data-id="element-94">
            <a href="#" className="hover:text-gold transition-colors" data-id="element-95">
              Términos y condiciones
            </a>
            <span className="hidden sm:inline" data-id="element-96">·</span>
            <a href="#" className="hover:text-gold transition-colors" data-id="element-97">
              Política de privacidad
            </a>
            <span className="hidden sm:inline" data-id="element-98">·</span>
            <a href="#" className="hover:text-gold transition-colors" data-id="element-99">
              Política de devolución
            </a>
            <span className="hidden sm:inline" data-id="element-100">·</span>
            <a href="#" className="hover:text-gold transition-colors" data-id="element-101">
              Contacto
            </a>
          </div>
          <p className="text-[9px] sm:text-xs text-violet-100/40 mt-4 sm:mt-6 max-w-3xl mx-auto leading-relaxed px-2" data-id="element-102">
            Los testimonios reflejan experiencias individuales reales. Los
            resultados pueden variar según la dedicación y el contexto de cada
            emprendedora. El producto es de descarga digital. El acceso se
            entrega de forma inmediata tras confirmación de pago.
          </p>
        </div>
      </div>
    </footer>;
}